module.exports = __webpack_public_path__ + "static/steve-newman-portfolio-31c017afa74102d4f3c977dce5f7420b.png";